module.exports = __webpack_public_path__ + "img/logo-bianco.19415598.png";